const API_BASE = '/api';

async function request<T>(method: string, path: string, body?: unknown, token?: string | null): Promise<T> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'حدث خطأ غير متوقع');
  return data as T;
}

export const api = {
  auth: {
    register: (data: { email: string; password: string; restaurant_name: string }) =>
      request<{ token: string; restaurant_code: string; restaurant_name: string }>('POST', '/auth/register', data),
    login: (data: { email: string; password: string }) =>
      request<{ token: string; restaurant_code: string; restaurant_name: string }>('POST', '/auth/login', data),
    driverLogin: (data: { restaurant_code: string; phone: string; pin: string }) =>
      request<{ token: string; driver_id: number; display_name: string; restaurant_code: string }>('POST', '/auth/driver-login', data),
  },
  drivers: {
    list: (token: string) =>
      request<{ drivers: Driver[] }>('GET', '/drivers', undefined, token),
    create: (data: { display_name: string; phone: string }, token: string) =>
      request<{ id: number; display_name: string; phone: string; pin: string }>('POST', '/drivers', data, token),
    delete: (id: number, token: string) =>
      request<{ message: string }>('DELETE', `/drivers/${id}`, undefined, token),
  },
  orders: {
    list: (token: string, status?: string) =>
      request<{ orders: Order[] }>('GET', `/orders${status ? `?status=${status}` : ''}`, undefined, token),
    create: (data: { customer_name: string; customer_phone: string; delivery_address: string; amount: number }, token: string) =>
      request<{ id: number; order_number: string }>('POST', '/orders', data, token),
    assign: (orderId: number, driverId: number, token: string) =>
      request<{ message: string }>('POST', `/orders/${orderId}/assign`, { driver_id: driverId }, token),
    updateStatus: (orderId: number, status: string, token: string) =>
      request<{ message: string; status: string }>('PUT', `/orders/${orderId}/status`, { status }, token),
  },
  push: {
    subscribe: (subscription: PushSubscriptionJSON, token: string) =>
      request<{ message: string }>('POST', '/push/subscribe', { subscription }, token),
  },
};

export interface Driver {
  id: number;
  display_name: string;
  phone: string;
  status: 'available' | 'busy' | 'offline';
  active_orders_count: number;
  created_at: string;
}

export interface Order {
  id: number;
  order_number: string;
  customer_name: string;
  customer_phone: string;
  delivery_address: string;
  amount: number;
  status: 'pending' | 'accepted' | 'in_delivery' | 'completed' | 'rejected';
  assigned_driver_id: number | null;
  driver_name?: string;
  created_at: string;
  accepted_at: string | null;
  completed_at: string | null;
}
